module.exports = __webpack_public_path__ + "img/ly.e0d6da1f.svg";